import { render } from "./TopRightGates.vue?vue&type=template&id=ee44533a"
import script from "./TopRightGates.vue?vue&type=script&lang=js"
export * from "./TopRightGates.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__